import React, { useState, useEffect, useContext } from 'react';
import './account-details-overview.scss';
import 'rsuite/dist/rsuite.min.css';
import { ActionLink, ModalWindow, Dropdown } from '../../../atoms';
import { default as t } from '../../../../utils/i18n';
import { DateRangePicker, Button } from 'rsuite';
import { UserContext, FilterContext } from '../../../../context';
import { AdminService } from '../../../../services';
import subDays from 'date-fns/subDays';
import InputGroup from 'rsuite/InputGroup';
import { DatePicker } from 'rsuite';
import { ReactComponent as EditIcon } from '../../../../assets/svg/edit.svg';
import { ReactComponent as SaveIcon } from '../../../../assets/svg/save.svg';

const AccountDetailsOverview = props => {
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const [accountDetails, setAccountDetails] = useState([]);
  const [accountsModalOverview, setAccountsModalOverview] = useState(false);
  const [showDeboardModal, setShowDeboardModal] = useState(false);
  const [usuageDetails, setUsuageDetails] = useState(null);
  const [diagnosticsDetails, setDiagnosticsDetails] = useState([]);
  const [usuageData, setUsuageData] = useState([]);
  const { filterDetails, setFilterDetails } = useContext(FilterContext);
  const countriesList = filterDetails?.countryList;
  const industriesList = filterDetails?.industryList;
  const verticalList = filterDetails?.verticalList;
  const { allowedRange } = DateRangePicker;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateDisable, setStartDateDisable] = useState(false);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [freq, setFreq] = useState('');

  const[supplyInfoEdit, setSupplyInfoEdit] = useState(false);
  const [addPayload, setAddPayload] = useState('');
  const [originalData, setOriginalData] = useState('')

  const predefinedRanges = [
    {
      label: 'Last 30 days',
      value: [subDays(new Date(), 29), new Date()],
      placement: 'left',
    },
    {
      label: 'Last 60 days',
      value: [subDays(new Date(), 59), new Date()],
      placement: 'left',
    },
    {
      label: 'Last 90 days',
      value: [subDays(new Date(), 89), new Date()],
      placement: 'left',
    },
    {
      label: 'Custom',
      value: 'custom',
    },
  ];

  useEffect(() => {
    setAccountsModalOverview(true);
    setFreq(predefinedRanges[0]);
    setEndDateDisable(false);
    getAccountDetails();
    handleDateRange(predefinedRanges[0].value);
    setSupplyInfoEdit(false);
  }, []);

  const handleBackClick = (isDelete = false) => {
    document.body.style.overflow = 'auto';
    setTimeout(() => {
      props.handleModalBackClick(isDelete, accountDetails?.adAccountId);
    }, 1000);
    setAccountsModalOverview(!accountsModalOverview);
  };

  async function getAccountDetails() {
    try {
      const bmResponse = await AdminService.getAdAccountDetails(
        userAccessToken,
        username,
        props?.accountID
      );
      let acResponse = { ...bmResponse?.data?.data };
      acResponse.accountUsersSync.nextSync = getTime({
        lastAttemptedAt: 0,
        syncInterval: acResponse?.accountUsersSync?.lastSuccessfullSync,
      });
      acResponse.historialCampaignSync.nextSync = getTime({
        lastAttemptedAt: acResponse?.historialCampaignSync?.lastPulledAt,
        syncInterval: 0,
      });
      acResponse.historicalAdsetsSync.nextSync = getTime({
        lastAttemptedAt: acResponse.historicalAdsetsSync.lastPulledAt,
        syncInterval: 0,
      });
      acResponse.historicalAdsSync.nextSync = getTime({
        lastAttemptedAt: acResponse.historicalAdsSync.lastPulledAt,
        syncInterval: 0,
      });
      let diagnostics = [
        {
          label: t('admin.adacc.last.users.sync'),
          status: acResponse?.accountUsersSync?.status,
          nextSync: acResponse.accountUsersSync.nextSync,
        },
        {
          label: t('admin.adacc.last.campaigns.sync'),
          status: acResponse?.historialCampaignSync?.status,
          nextSync: acResponse.historialCampaignSync.nextSync,
        },
        {
          label: t('admin.adacc.last.adsets.sync'),
          status: acResponse?.historicalAdsetsSync?.status,
          nextSync: acResponse.historicalAdsetsSync.nextSync,
        },
        {
          label: t('admin.adacc.last.ads.sync'),
          status: acResponse?.historicalAdsSync?.status,
          nextSync: acResponse.historicalAdsSync.nextSync,
        },
      ];
      setDiagnosticsDetails([...diagnostics]);
      setOriginalData(acResponse)
      setAccountDetails(acResponse);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }
  const getTime = value => {
    const date = new Date(value.lastAttemptedAt + value.syncInterval);
    return date.toLocaleString();
  };

  const handleDateRange = date => {
    setStartDate(new Date(date[0]));
    setEndDate(new Date(date[1]));
    let startDate = updateDateFormatApi(date[0]);
    let endDate = updateDateFormatApi(date[1]);
    getUsuageDetailsBasedOnFreq(startDate, endDate);
  };

  const updateDateFormatApi = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1;
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    return yyyy + '-' + mm + '-' + dd;
  };

  async function getUsuageDetailsBasedOnFreq(startDate, endDate) {
    try {
      const ususgeRes = await AdminService.getUsageDetails(
        userAccessToken,
        username,
        'adaccount',
        props?.accountID,
        startDate,
        endDate
      );
      let reultRes = ususgeRes?.data?.data;
      let ususgeVal = [
        {
          label: t('admin.bm.details.campaign.insights'),
          result: `${reultRes?.scheduledCampaignInsights}/${reultRes?.deliveredCampaignInsights}`,
        },
        {
          label: t('admin.bm.details.optmi'),
          result: `${reultRes?.scheduledCampaignOptimizationAnalysis}/${reultRes?.deliveredCampaignOptimizationAnalysis}`,
        },
        {
          label: t('admin.bm.details.eocr'),
          result: `${reultRes?.scheduledEOCRReports}/${reultRes?.deliveredEOCRReports}`,
        },
        {
          label: t('admin.bm.details.pca'),
          result: `${reultRes?.scheduledPCAReports}/${reultRes?.deliveredPCAReports}`,
        },
        {
          label: t('admin.bm.details.Scheduled'),
          result: `${reultRes?.scheduledLiveReports}/${reultRes?.deliveredLiveReports}`,
        },
      ];
      setUsuageData([...ususgeVal]);
      setUsuageDetails({ ...reultRes });
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const onClickOfDeboard = () => {
    setShowDeboardModal(true);
  };

  const Cell = ({ label, status, nextSync }) => {
    return (
      <div className="label_container">
        <div className="label_name">{label}</div>
        <div className="label_value">
          {status !== 'SUCCESS' && <i className="eva  eva-alert-triangle yellow"></i>}
          {status === 'SUCCESS' && <i className="eva  eva-checkmark-circle-2"></i>}
          {status} | {nextSync ? <span>{nextSync}</span>: <span>{t('sync.date.time.not.available')}</span>}
        </div>
      </div>
    );
  };

  const UsusgeCell = ({ label, result }) => {
    return (
      <div className="label_container">
        <div className="label_name">{label}</div>
        {!startDate && !endDate ? <div className="label_value">0/0</div> :<div className="label_value">{result}</div>}
      </div>
    );
  };

  const handleOnCancel = e => {
    e.preventDefault();
    setShowDeboardModal(false);
  };

  const onDeleteContinue = () => {
    const payload = {
      is_excluded: true,
    };
    updateSupplementaryInfo(payload, true);
  };

  const getVal = (list, code) => {
    return list?.find(li => li.value === code);
  };

  const handleSelect = (option, selectedDropdown) => {
    const payload = {
      countryCode: selectedDropdown === 1 ? option.value : accountDetails?.countryCode,
      vertical: selectedDropdown === 2 ? option.value : accountDetails?.industry,
      subVertical: selectedDropdown === 3 ? option.value : accountDetails?.subVertical,
      is_excluded: false,
    };
    setAccountDetails({...accountDetails,
      countryCode: payload.countryCode,
      industry: payload.vertical,
      subVertical: payload.subVertical
    })
    setAddPayload(payload);
   // updateSupplementaryInfo(payload);
  };

  async function updateSupplementaryInfo(payload, isDelete) {
    try {
      const listResponse = await AdminService.updateSupplementaryInfo(
        userAccessToken,
        username,
        payload,
        props?.accountID
      );
      if (isDelete) {
        handleBackClick(true);
      } else {
        setSupplyInfoEdit(false)
        const verticalListRes = listResponse.data?.data;
        getAccountDetails();
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  }

  const onStartDateChange = val => {
    if (val && val !== null) {
      setFreq(predefinedRanges[3]);
      setStartDate(new Date(val));
      setEndDateDisable(false);
      setEndDate(null);
    } else {
      setFreq(freq);
      setStartDate(val);
      setEndDate(null);
      setEndDateDisable(true);
    }
  };

  const onEndDateChange = val => {
    if (val && val !== null) {
      setFreq(predefinedRanges[3]);
      setEndDate(new Date(val));
      handleDateRange([new Date(startDate), new Date(val)]);
    } else {
      setFreq(freq);
      setEndDate(val);
    }
  };

  const handleSelectDate = freqency => {
    setFreq(freqency);
    if(freqency.value !== 'custom') {
      setEndDateDisable(false);
      handleDateRange(freqency.value);
    } else {
      setEndDateDisable(true);
      setStartDate(null);
      setEndDate(null);
    }
  };

  const onClickOfEdit = () => {
    setSupplyInfoEdit(true)
  }

  const onClickOfSave =() => {
   updateSupplementaryInfo(addPayload);
  }

  const onCancel = () => {
    setAccountDetails({...accountDetails,
      countryCode: originalData?.countryCode,
      industry: originalData?.industry,
      subVertical: originalData?.subVertical
    })
    setSupplyInfoEdit(false)
  }

  return (
    <>
      <div className={`attribute-detail-view-overlay ${accountsModalOverview ? 'show' : 'hide'}`}>
        <div className="attribute-detail-view">
          <div className="attribute-detail-view-buttongroup">
            <button className="return-insights" onClick={() => handleBackClick()}>
              <i className="eva  eva-arrow-ios-back-outline"></i>
              {t('user.buttonText.back')}
            </button>
          </div>
          <div className="import-campaign-cta">
            <div className="accounts_header">
              {t('admin.ac.details.account.id')}: &nbsp;{accountDetails?.adAccountId}
            </div>
          </div>
          <div className="account-detail-container">
            <div className="details-header">
              <h3>{t('admin.bm.details.bmId')}:&nbsp;</h3>
              <span>{accountDetails?.adAccountName}</span>
            </div>
            <div className="account-details">
              <div className="diagnostics_container">
                <div className="diagnostics-header">{t('admin.bm.details.diagnostics')}</div>
                <div className="diagnostics_separator">
                  <div className="separator_one">
                    {diagnosticsDetails?.map(res => {
                      return (
                        <Cell label={res?.label} status={res?.status} nextSync={res?.nextSync} />
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="date_range_container">
                <div className="business_name">{t('admin.bm.details.select.date.range')}</div>
                <div className="date-usage">
                  <div className="c-dropdown-country">
                    <Dropdown
                      className="user-select"
                      heading={t('admin.ac.details.freq')}
                      options={predefinedRanges}
                      placeholder={t('admin.ac.select.freq')}
                      tooltipIndicator={false}
                      isImportant={false}
                      value={freq}
                      onSelect={handleSelectDate}
                    />
                  </div>
                  <div className="bottom-section date_picker_width">
                    <InputGroup>
                      <DatePicker
                        id="start-date"
                        disabled={startDateDisable}
                        format="dd-MM-yyyy"
                        value={startDate}
                        onChange={onStartDateChange}
                        disabledDate={allowedRange(new Date('04-01-2022'), new Date())}
                        placeholder={t('report.wrapper.start.date')}
                        oneTap
                      />
                      <InputGroup.Addon>to</InputGroup.Addon>
                      <DatePicker
                        id="end-date"
                        disabled={endDateDisable}
                        format={"dd-MM-yyyy"}
                        value={endDate}
                        onChange={onEndDateChange}
                        disabledDate={allowedRange(startDate, new Date())}
                        placeholder={t('report.wrapper.end.date')}
                        oneTap
                      />
                    </InputGroup>
                  </div>
                </div>
              </div>

              <div className="diagnostics_container usage_block">
                <div className="diagnostics-header">
                  <div>{t('admin.bm.details.usuage')}</div>
                  <div>{t('admin.bm.details.req')}</div>
                </div>
                <div className="diagnostics_separator">
                  <div className="separator_one">
                    {usuageData?.map(res => {
                      return <UsusgeCell label={res?.label} result={res?.result} />;
                    })}
                  </div>
                </div>
              </div>

              <div className="diagnostics_container usage_block">
                <div className="diagnostics-header align_icons">
                  <div>{t('admin.adaccount.sup.info')}</div>
                  <Button appearance="link">
                {!supplyInfoEdit && <EditIcon onClick={() => onClickOfEdit()}/>}
                {supplyInfoEdit && <SaveIcon onClick={() => onClickOfSave()} />}
                {supplyInfoEdit && <span className='cancel_edit' onClick={() => onCancel()}>{t('sup.cancel')}</span>}
              </Button>
                </div>
                <div className="c-dropdown-country">
                  <Dropdown
                    className="user-select"
                    heading={t('admin.adaccount.country')}
                    value={getVal(countriesList, accountDetails?.countryCode)}
                    options={countriesList}
                    placeholder={t('admin.add.country')}
                    tooltipIndicator={false}
                    isImportant={false}
                    onSelect={opt => handleSelect(opt, 1)}
                    isDisabled={!supplyInfoEdit}
                  />
                </div>
                <div className="c-dropdown-country">
                  <Dropdown
                    className="user-select"
                    heading={t('admin.adaccount.industry')}
                    value={getVal(industriesList, accountDetails?.industry)}
                    options={industriesList}
                    placeholder={t('admin.add.industry')}
                    tooltipIndicator={false}
                    isImportant={false}
                    onSelect={opt => handleSelect(opt, 2)}
                    isDisabled={!supplyInfoEdit}
                  />
                </div>
                <div className="c-dropdown-country">
                  <Dropdown
                    className="user-select"
                    heading={t('admin.adaccount.vertical')}
                    value={getVal(verticalList, accountDetails?.subVertical)}
                    options={verticalList}
                    placeholder={t('admin.add.sub.vertical')}
                    tooltipIndicator={false}
                    isImportant={false}
                    onSelect={opt => handleSelect(opt, 3)}
                    isDisabled={!supplyInfoEdit}
                  />
                </div>
              </div>

              <button className="step-back" onClick={onClickOfDeboard}>
                {t('admin.bm.details.deboard.account')}
              </button>
            </div>
          </div>
        </div>
        <div className="attr-delete">
          <ModalWindow
            className="fqa-modal--showanswer"
            isOpen={showDeboardModal}
            onRequestClose={handleOnCancel}
            heading={t('admin.bm.details.deboard.header')}
            ariaHideApp={false}
            appElement={document.getElementById('app')}
          >
            <p className="fqa-model-showanswer--message message-font">
              {t('admin.bm.details.deboard.subheader')}
            </p>
            <div className="fqa-model-pa--actions">
              <ActionLink
                anchor={true}
                value={t('reportTable.campaign.delete.cancel')}
                handleClick={handleOnCancel}
              />
              <Button
                className="fqa-model-pa--actions-confirm delete-button"
                onClick={onDeleteContinue}
              >
                {t('admin.bm.details.delete')}
              </Button>
            </div>
          </ModalWindow>
        </div>
      </div>
    </>
  );
};
export default AccountDetailsOverview;
